import { Box } from '@gazin/ecommerce-ui'
import styled from 'styled-components'

type InformationProps = {
  $showMore: boolean
}

export const Description = styled(Box)`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 0.0625rem !important;

    b {
      font-size: 1rem !important;
      @media (max-width: 30rem) {
        font-size: 0.875rem !important;
      }
    }
  }

  p {
    font-size: 1rem !important;
    line-height: 1.25rem !important;
    @media (max-width: 30rem) {
      line-height: 1.375rem !important;
      font-size: 0.875rem !important;
    }
  }

  ul li {
    list-style: disc;
    margin-left: 1.25rem;
  }

  @media (max-width: 30rem) {
    margin-bottom: 1rem;

    ul li {
      margin-left: 1rem;
    }
  }
`

export const Information = styled(Box)<InformationProps>`
  h2 {
    margin-bottom: 0;
  }

  div:first-child {
    div:first-child {
      div {
        max-height: ${({ $showMore }) => !$showMore && 'none !important'};
      }
      button {
        display: ${({ $showMore }) => !$showMore && 'none !important'};
      }
    }
  }
`

export const Sheet = styled(Box)`
  h2 {
    margin-bottom: 0;
  }
  @media (max-width: 61.938rem) {
    padding-top: 0rem;
  }

  @media (max-width: 30rem) {
    margin-top: 0;
    padding: 0;

    .item {
      flex-direction: column;
      align-items: center;
    }
  }
`
